<script setup lang="ts">
import BaseIcon from '@/components/ui/BaseIcon.vue';
import type { IconName } from '@/libs/icons';

defineProps<{
  icon?: IconName;
  title: string;
  description?: string;
}>();
</script>

<template>
  <div class="empty-state">
    <BaseIcon v-if="icon" :name="icon" :size="20" class="empty-state__icon" />
    <div class="empty-state__text">
      <p class="empty-state__title">{{ title }}</p>
      <p v-if="description" class="empty-state__description">{{ description }}</p>
    </div>
    <slot name="actions" />
  </div>
</template>

<style lang="scss">
.empty-state {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: $spacing-4;
  justify-content: center;
  padding: $spacing-6 24px;
  text-align: center;

  &__icon {
    color: $color-neutral-highest;
    margin: 2px;
  }

  &__text {
    max-width: 360px;
    overflow-wrap: break-word;
    width: 100%;
  }

  &__title {
    color: $color-neutral-highest;
    font: $label-medium;
    letter-spacing: $label-medium-spacing;
    margin: 0;
  }

  &__description {
    color: $color-text-neutral;
    font: $label-small;
    letter-spacing: $label-small-spacing;
    margin: 0;
  }
}
</style>
